<template>
  <div class="content-wrapper main">
    <div class="main-top-slider-wrapper">
      <div
        class="main-top-slide"
        style="background-image: url(upload/iblock/60c/60cd587f0bfa0b92084a1409065d1882.jpg)"
        id="bx_3218110189_2621"
      >
        <router-link :to="{ name: 'solutions' }"></router-link>
        <div class="slide-text">
          <p></p>
          <div></div>
        </div>
      </div>

      <div
        class="main-top-slide"
        style="background-image: url(upload/iblock/478/478e676945d01e13ca3be74c58de2572.jpg)"
        id="bx_3218110189_2133"
      >
        <a
          @click.prevent
          href="catalog/klei-i-germetiki/sikaflex-11-fc/index.html"
        ></a>
        <div class="slide-text">
          <p></p>
          <div></div>
        </div>
      </div>
    </div>
    <div class="mob-top-slider">
      <div
        class="banner-slide"
        style="background-image: url(upload/iblock/7cc/7ccdc1163d8763cf3ea4775953e9d929.jpg)"
      ></div>
    </div>
    <div class="main-gray-menu">
      <div class="b-services">
        <v-fade-transition>
          <div class="b-services__list" v-if="!_.isEmpty(categories)">
            <div
              v-for="(category, id) in categories"
              class="b-services__item"
              id="bx_1847241719_"
              :key="id"
            >
              <router-link
                class="b-services__link"
                :to="{
                  name: category.id === 6 ? 'subCategory' : 'category',
                  params: {
                    groupId: category.id === 6 ? 11 : category.id,
                    pGroupId: category.id === 6 ? 6 : undefined,
                  },
                }"
              >
                <span
                  class="b-services__item-img"
                  :style="{ backgroundImage: 'url(' + category.img + ')' }"
                ></span>
                {{ category.name }}
              </router-link>
            </div>
          </div>
        </v-fade-transition>
      </div>
    </div>
    <div class="main-text">
      <div class="main-text-left-column">
        <router-link
          :to="{
            name: 'about',
          }"
          class="h2"
          >О компании</router-link
        >
        <div class="b-main-content">
          <div class="b-main-content__img-block">
            <img
              src="upload/medialibrary/257/2572e3235ada997365dab5a2687e6d2e.jpg"
            />

            <p class="image-title">
              Завод сухих строительных смесей Sika Россия в г. Ржев
            </p>
          </div>
          <div class="b-main-content__text">
            <p>
              Sika – швейцарский концерн по производству материалов для
              строительства, работающий с 1910 года. В состав компании входят
              производственные предприятия, научные лаборатории, центры
              технической поддержки и торговые представительства более чем в 100
              странах мира. В компании работает свыше 20 000 сотрудников. В
              России компания работает с 2003 года и имеет 5 заводов по
              производству добавок в бетон, 2 завода по производству сухих
              строительных смесей, завод по выпуску напольных покрытий, завод по
              производству ПВХ мембран, лабораторию физико-химических испытаний
              бетонов и бетонных смесей, химическую лабораторию и 5 филиалов в
              разных регионах страны с центральным офисом в городе Лобня
              Московской области.
            </p>

            <p>
              Материалы и решения Sika, предлагаемые для частного использования,
              прошли проверку на профессиональных строительных объектах всего
              мира.
            </p>
          </div>
        </div>
        <div style="clear: both;"></div>
        <br />
        <div class="main-sections">
          <div>
            <a
              class="h2"
              target="_blank"
              href="upload/medialibrary/9bc/catalog21.08.pdf"
              >Каталог PDF</a
            >
            <a
              target="_blank"
              href="upload/medialibrary/9bc/catalog21.08.pdf"
              style="background-image: url(upload/medialibrary/4d2/4d251f4b4bd41f2b0a72814e4e88f265.jpg)"
            ></a>
          </div>
          <div>
            <router-link :to="{ name: 'video', params: { id: 1 } }" class="h2"
              >Видео</router-link
            >
            <router-link
              :to="{ name: 'video', params: { id: 1 } }"
              style="background-image: url(upload/medialibrary/ab2/ab2e60d8ff2d05d721b3f0f1bd040718.jpg)"
            ></router-link>
          </div>
          <div>
            <router-link class="h2" :to="{ name: 'objects' }"
              >Объекты</router-link
            >
            <router-link
              class="h2"
              :to="{ name: 'objects' }"
              style="background-image: url(upload/medialibrary/82f/82fe9a07210f2f2270859824f24ad0d9.jpg)"
            ></router-link>
          </div>
          <h1 class="h3-style">
            Сухие строительные смеси Sika. Качество из Швейцарии
          </h1>
          <p>
            Сухие смеси и другая строительная химия, а также материалы для
            промышленности под маркой Sika – это продукция европейского
            качества. Международный концерн Sika, основанный в Швейцарии, уже
            более 100 лет производит передовые материалы для профессионального
            строительства и частного использования. В научных лабораториях
            создаются новаторские технологии, на собственных заводах ведется
            изготовление сухих строительных смесей и других продуктов,
            высочайшее качество которых признано по всему миру. Сотни тысяч
            объектов на всех континентах были построены с помощью материалов
            Sika.
          </p>
          <h2 class="h4-style">Российское производство</h2>
          <p>
            Строительные смеси Sika, химия и материалы для промышленности
            представлены в России с 2003 года. Производство продукции
            осуществляется в Европе и на собственных предприятиях, которые
            построены и оборудованы в соответствии с международными стандартами
            компании. На сегодняшний день в России работает 5 заводов по выпуску
            добавок в бетон, завод по производству поликарбоксилатных эфиров, 2
            завода сухих строительных смесей, завод по выпуску напольных
            покрытий, завод по производству ПВХ мембран, 2 лаборатории.
          </p>
          <h2 class="h4-style">Sika для строительства и отделки</h2>
          <p>
            Для частного использования Sika выпускает широкий ассортимент
            продукции, необходимой на всех этапах строительства и отделки. Это
            сухие смеси, материалы для устройства полимерных полов, материалы
            для отделки стен и фасадов, гидроизоляция, материалы для укладки
            плитки, материалы для укладки паркета, клеи и герметики,
            строительные клеи и анкеровка, добавки в бетон.
          </p>
          <p>
            Материалы Sika прошли многократные испытания на промышленных
            объектах по всему миру. Предлагая сухие строительные смеси и другую
            строительную химию, производитель гарантирует их высочайшее
            качество.
          </p>
          <p>
            Продажа сухих строительных смесей и другой продукции Sika
            осуществляется через партнеров компании во многих городах России.
          </p>
        </div>
      </div>
      <div class="main-text-right-column">
        <router-link class="h2 mb-8" :to="{ name: 'articles' }"
          >Статьи</router-link
        >
        <div
          v-for="(article, index) in articles.items"
          :key="index"
          class="main-news-teaser"
          id="bx_3485106786_2695"
        >
          <span>{{ article.date }}</span>
          <router-link :to="{ name: 'article', params: { id: article.id } }">{{
            article.title
          }}</router-link>
          <p></p>
        </div>
      </div>
    </div>
    <br />
    <div id="dc_vk_code" style="display:none"></div>
    <br />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      catImgs: [
        "upload/iblock/1b0/1b04ff7d09f3c6d5f6edfad9da4d44c6.png",
        "upload/iblock/a23/a231c733b7eafc7bb38bfcea919e304d.png",
        "upload/iblock/826/8263b31bd8f26e3bafaaaf7fe1d4a455.png",
        "upload/iblock/6c7/6c75c4d1f784f19abe699c6b523739a2.png",
        "upload/iblock/42e/42ed049ba4b9d1451ff9a4f9e370da1b.png",
        "upload/iblock/233/2333576efce34a7ae9b2937b1e174eeb.png",
        "upload/iblock/d93/d93ad69f13c9b6eee3a833ba41698ec0.png",
        "upload/iblock/9b1/9b1baca2f6160481fbd47b87d7786265.png",
        "upload/iblock/d73/d73c0223fccd9a9f272f36782f04d6b2.png",
        "upload/iblock/d73/d73c0223fccd9a9f272f36782f04d6b2_.png",
      ],
    };
  },
  computed: {
    categories() {
      let out = {};
      let index = 0;
      for (let [id, category] of Object.entries(this.cat)) {
        out = {
          ...out,
          [category.id]: { ...category, img: this.catImgs[index] },
        };
        index++;
      }
      return out;
    },
    ...mapState(["cat", "articles"]),
  },
};
</script>

<style lang="scss">
.main {
  position: relative;
  .main-gray-menu {
    min-height: 196px;
  }

  .owl-item {
    padding-right: 5px;
  }

  // Корреция Vuetify
  .main-gray-menu {
    *,
    ::before,
    ::after {
      -webkit-box-sizing: unset;
      box-sizing: unset;
    }
  }
}

@media screen and (min-width: 1200px) {
  .mob-top-slider {
    display: none;
  }
}
</style>
